// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-2ecIkIpV","box_up":"box_up-M47ym1X2 clearfix","box_down":"box_down-v-NkHfeq clearfix","pic":"pic-R4eDaFNW","text":"text-2wHyrQfc","detail":"detail-14MZ2e27"};